const NoMatch = () => {
  return (
    <p style={{ fontSize: "2.5vw", padding: "20px" }}>
      The page you are looking for doesn't exist. Try to get back to the
      <a href="/"> home page</a>
    </p>
  );
};

export default NoMatch;
